/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Folder_Structure_LostInputs */



/**
* | output |
* | --- |
* | "Your browser does not support folder uploads. Files were added without folder structure." |
*
* @param {Spaces_Toast_Folder_Structure_LostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_folder_structure_lost = /** @type {((inputs?: Spaces_Toast_Folder_Structure_LostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Folder_Structure_LostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Browser unterstützt keine Ordner-Uploads. Dateien wurden ohne Ordnerstruktur hinzugefügt.")
	return /** @type {LocalizedString} */ ("Your browser does not support folder uploads. Files were added without folder structure.")
});